import ServiceHeader2 from '../shared/service-header2';
import AboutUs from './about-us';
import Articles from './articles';
import { Introduction } from './introduction';

const ServiceNotarization = () => (
  <main className='w-full overflow-hidden bg-paper'>
    <ServiceHeader2 />
    <Introduction />
    <AboutUs />
    <Articles />
  </main>
);

export default ServiceNotarization;
